var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrades(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_146)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_830_146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000144958H49.9999V50H0V0.000144958Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_830_146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3945 30.9003H40.9297C42.3794 30.9003 43.5546 32.0755 43.5546 33.5252V43.3393C43.5546 46.4785 41.0097 49.0234 37.8704 49.0234H12.1295C8.99023 49.0234 6.44531 46.4785 6.44531 43.3393V33.5252C6.44531 32.0755 7.6205 30.9003 9.07021 30.9003H20.6054",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4459 30.8027V26.1808H9.5542V30.8027",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0991 39.9619C29.0991 37.6979 27.2639 35.8626 24.9998 35.8626C22.7359 35.8626 20.9006 37.6979 20.9006 39.9619C20.9006 42.2259 22.7359 44.0613 24.9998 44.0613C27.2639 44.0613 29.0991 42.2259 29.0991 39.9619Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8064 26.1808C38.8064 23.4122 36.5621 21.1679 33.7935 21.1679C32.7932 21.1677 31.8113 20.8992 30.9501 20.3904C30.0888 19.8816 29.3799 19.151 28.8971 18.275L28.8966 18.2741L28.3631 18.9722C27.8413 19.6549 27.1691 20.2082 26.3988 20.589C25.6285 20.9698 24.7807 21.1679 23.9214 21.1679H16.2065C13.4379 21.1679 11.1936 23.4122 11.1936 26.1808H38.8064Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7351 7.02201L25.1907 10.5665",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4868 8.45667C30.5069 10.4365 27.734 11.1396 25.1906 10.5665C24.6175 8.02318 25.3205 5.25023 27.3005 3.27036C28.7198 1.85093 30.5467 1.08784 32.4044 0.98052C33.7476 0.902982 34.8541 2.00952 34.7766 3.35268C34.6693 5.21039 33.9062 7.03734 32.4868 8.45667Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6682 9.94298L24.8093 13.084",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5131 10.9741C19.4929 12.954 22.2659 13.6571 24.8093 13.0839C25.3824 10.5406 24.6794 7.76765 22.6994 5.78777C21.28 4.36834 19.4532 3.60526 17.5955 3.49803C16.2523 3.4205 15.1458 4.52694 15.2233 5.8701C15.3306 7.7279 16.0937 9.55475 17.5131 10.9741Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0024 8.57256V15.8558",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1716 15.5662H43.7498",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4609 13.277V17.8552",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.7769H10.8282",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53906 8.48786V13.0662",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_146"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrades);
export default __webpack_public_path__ + "static/media/trades.92bf02441150531203456b3a256c45c1.svg";
export { ForwardRef as ReactComponent };